import { useEffect, useRef } from "react";
import React from "react";
import {Html5QrcodeScanner, Html5QrcodeScanType, Html5QrcodeSupportedFormats} from "html5-qrcode";
import {Html5QrcodeScannerConfig} from "html5-qrcode/html5-qrcode-scanner";

type Props = {
    onScanSuccess: (decodedText: string) => void;
    onScanFailure?: (errorMessage: string) => void;
    fps?: number;
    qrbox?: number;
};

export function BarCodeScanner({
    onScanSuccess,
    onScanFailure,
    fps = 100,
    qrbox = 1000,
}: Props) {
    const readerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (readerRef.current) {
            const config: Html5QrcodeScannerConfig = {
                fps,
                qrbox,
                useBarCodeDetectorIfSupported: true,
                formatsToSupport: [Html5QrcodeSupportedFormats.CODE_128],
                supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
                showZoomSliderIfSupported: true,
            };

            const scanner = new Html5QrcodeScanner("barcode-reader", config, false);
            scanner.render(onScanSuccess, onScanFailure);

            return () => {
                scanner.clear().catch((error) => {
                    console.error("Failed to clear CODE_128 Scanner", error);
                });
            };
        }
    }, [fps, qrbox, onScanSuccess, onScanFailure]);

    return <div id="barcode-reader" ref={readerRef}></div>;
}

